import { startOfDay, subDays } from "date-fns";

export const APPLICATION_TYPE_RE_PLEDGE = "RE_PLEDGE";
export const APPLICATION_SUB_TYPE_POST_PLEDGE = "POST_PLEDGE";
export const APPLICATION_SUB_TYPE_PRE_PLEDGE = "PRE_PLEDGE";
export const APPLICATION_TYPE_BT = "BT";
export const APPLICATION_TYPE_New = "NEW";
export const LOAN_STATUS_CLOSED = "CLOSED";
export const APPLICATION_CREATED_MESSAGE = "Application successfully created";
export const PACKET_ALREADY_ASSIGNED = "packet already assign";
export const CHECK_LOAN_MARKINGS = {
    spuriousGold:"SPURIOUS_GOLD",
    death:"DEATH",
    legal:"LEGAL",
    unacceptableItem:"UNACCEPTABLE_ITEM",
}
export const OccupationListData = [
    "Agriculture",
    "Self Employed",
    "Government Employee",
    "Private Employee",
    "Unemployed",
    "Housewife",
    "Agriculture Labourer",
    "Skilled Labourer",
    "Others",
  ];

export const purposeOfLoanListData = ["Agriculture", "Business", "Personal"];
export const fullSourceOfOwnershipOptions = [
"Self purchased- bill available",
"Self purchased- bill not available",
"Ancestral from father",
"Ancestral from mother",
"Ancestral from grand father",
"Ancestral from grand mother",
]

export const simplifiedSourceOfOwnershipOptions = [
"Self purchased",
"Ancestral from father",
"Ancestral from mother",
"Ancestral from grand father",
"Ancestral from grand mother",
]

export const packetSizesOptions = [
    {code:"3.0*3.0*",name:"3.0*3.0"},
    {code:"3.0*6.0*",name:"3.0*6.0"},
    {code:"6.0*3.0*",name:"6.0*3.0"},
    {code:"6.0*6.0*",name:"6.0*6.0"},
    {code:"10.0*6.5*",name:"10.0*6.5"},
]

export const userRole= {
    roleBranchManager : "role_branch_manager",
    roleHeadManager :"role_head_manager",
    roleChecker : "role_checker",
    roleMaker : "role_maker",
    roleMakerChecker : "role_maker_checker",
    roleAuditor :"role_auditor",
    roleAdminSuperUser:"role_admin_super_user",
    roleOperation:"role_operation",
    roleReportViewer:"role_report_viewer",
  };

  export const designation= {
    Glo:"GLO",
    BM:"BM",
    RM:"RM",
    RAM:"RAM",
    BH:"BH",
    ABM:"ABM",
    CRE:"CRE",
    Banker:"BANKER",
    HR:"HR",
    AreaManager:"AREA MANAGER",
    AuctionManager:"AUCTION MANAGER",
    Associate:"ASSOCIATE",
    FinanceExecutive:"FINANCE EXECUTIVE",
    AdminUser:"ADMIN USER",
    SrOperationExecutive:"Sr. OPERATION EXECUTIVE",
    OperationExecutive:"OPERATION EXECUTIVE",
    Auditor:"AUDITOR",
    VicePresident:"VICE PRESIDENT"
  }
export const GenderListData = ["Male", "Female", "Other"];
export const PreFixNameList = ["Mr", "Mrs", "Miss"];

export const setyear = (year) => {
  var date = new Date();
  date.setFullYear(date.getFullYear() - year);
  return date; //# => Thu Mar 31 2011 11:14:50 GMT+0200 (CEST)
};

export const insuranceTableColumns = [
  {id:"suminsured", label: "Sum Insured"},
  {id:"premium", label: "Premium ( without gst)"},
  {id:"gst",label:"GST"},
  {id:"totalPremium",label:"Total Premium"},
];

export const preferredLanguageData=[
  { code: "English", name: "English" },
  { code: "Hindi", name: "Hindi" },
];

export const InstallmentTable = [
       { id: "label", label: "Sr. No." },
       { id: "principalAmount", label: "Principal Amount" },
       { id: "openingBalance", label: "Opening Balance" },
       { id: "interestAmount", label: "Interest Amount" },
       { id: "installmentAmount", label: "Installment Amount" },
       { id: "date", label: "Disbursal Date" },
     ];

export const loanSchemeDetailTable = [
       { id: "adjustment", label: "Adjustment" },
       { id: "adjustedAmount", label: "Adjusted Amount" },
       { id: "adjustedAmountWithoutGst", label: "Adjusted Amount With out GST" },
       { id: "cgstAmount", label: "Cgst Amount" },
       { id: "chargeType", label: "Charge Type" },
       { id: "excludingGst", label: "Excluding Gst" },
       { id: "gstApplicable", label: "GST Applicable" },
       { id: "igstAmount", label: "Igst Amount" },
       { id: "sgstAmount", label: "Sgst Amount" },
     ];

export const personalLoanColumns = [
  { id: "leadid", label: "Lead ID" },
  { id: "created", label: "Created By" },
  { id: "createdOn", label: "Created On" },
  { id: "accountNumber", label: "Loan Account Number" },
  { id: "customerid", label: "Customer Id" },
  { id: "customerName", label: "Customer Name" },
];

export const statusBaseFilter = [
    { code: "INPROCESS", name: "In-Process" },
    { code: "SUBMITTED", name: "Submitted" },
    { code: "LEAD_REPAYMENT_SCHEDULE", name: "Lead Repayment Schedule" },
    { code: "LEAD_SANCTION_ESTAMP", name: "Lead Sanction Estamp" },
    { code: "LEAD_SANCTION_ESIGN", name: "Lead Sanction Esign" },
    { code: "COMPLETED", name: "Completed" },
    { code: "REJECTED", name: "Rejected" },
  ];


export const adminPannelData = [
      { id: "leadid", label: "Loan Application ID" },
      { id: "created", label: "Created By" },
      { id: "formNumber", label: "Application Number" },
      { id: "accountNumber", label: "Loan Account Number" },
      { id: "customerid", label: "Customer Id" },
      { id: "mobile", label: "Mobile Number" },
      { id:"status", label:"Status"},
      { id: "action", label: "Action" },
]

export const aadharVendor= {
  authBridgeOCR: "AUTHBRIDGE_ADHAAR_OCR",
  smcAuthBridgeOCR: "SMC_ADHAAR_OCR",
  authBridgeDigiLocker:"AUTHBRIDGE_DIGILOCKER",
  smcAuthBridgeDigiLocker:"SMC_DIGILOCKER",
  ongridDigiLocker:"ONGRID_DIGILOCKER",
  authBridgeCaptcha:"AUTHBRIDGE_ADHAAR_CAPTCHA",
  manual:"MANUAL",
  surePass:"SUREPASS",
  smcEKYC:"SMC_EKYC",
}

export const prefixToGenderMap = {
  "Mr": "Male",
  "Mrs": "Female",
  "Miss": "Female",
};

export const genderToPrefixMap = {
  "Male": "Mr",
  "Female": "Mrs",
  "Other": "Mr",
};

export const loanStatusNames ={
  inProcess:"INPROCESS",
  submitted:"SUBMITTED",
  aadhaar:"AADHAR",
}

export const documentNamesList = {
  aadhaar: "AADHAR_CARD",
  pan: "PAN",
  passport: "PASSPORT",
  voterId: "VOTER_ID",
  drivingLicense: "DRIVING_LICENSE",
  otherDocuments: "OTHER"
}

export const vendorNameList = {
  ocr:"OCR",
  digilocker:"DigiLocker",
  manual:"Manual",
  EKYC:"EKYC",
}

export const repledgeCaseListName = {
  topUp:"TOP_UP",
  partRelease:"PART_RELEASE",
  renew:"RENEWAL",
}

export const loanApplicationStatusNamesList = {
  rePledge: "rePledge",
  btLoan:"btLoan"
}

export const functionVariableNamesList = {
  aadhaar:"aadhar",
  panNumber:"withPanNumber",
}

export const documentCasesNames = {
  case1:"documentImage1",
  case2:"documentImage2",
  case3:"documentImage3",
  case4:"documentImage4",
  case5:"documentImage5",
  customer:"CUSTOMER",
  ornament:"ORNAMENT",
  kyc:"KYC",
  occupation:"occupation",
}

export const collateralOperationStatus = {
  inBranch : "IN_BRANCH",
  receivedFromHO: "RECEIVED_FROM_HO"
} 

export const disbursalScreenTableColumns =  [
    "Disbursal Amount",
    "Adjustment",
    "Adjusted Account / Amount",
    "Net Amount Payable",
    "Cash",
    "Bank",
  ]

  export const loanApplicationStatus = {
    inProcess:"INPROCESS",
    aadhaar:"AADHAR",
    selfie:"SELFIE",
    collateralEvaluation:"COLLATERALEVALUATION",
    forApproval:"FORAPPROVAL",
    disbursal:"DISBURSAL",
    disburseToLms:"DISBURSALTOLMS",
    submitted:"SUBMITTED",
    completed:"COMPLETED",
    rejected:"REJECTED",
    approved:"APPROVED",
    discrepancy:"DISCREPANCY",
    preSanction:"PRESANCTION",
    deviation:"DEVIATION",
    collateralApproval:"COLLATERALAPPROVAL",
  }

  export const fieldAgentTabsName = {
  loanDetails: "Loan Details",
  applicant: "Applicant",
  lenderDetails: "Lender Details ",
  pawanTicketDetails: "Pawan Ticket Details",
  review: "Review",
  bankDetails: "Bank Details",
  nomineeDetails: "Nominee Details",
  document: "Document",
  forApproval: "For Approval",
  disbursalDetails: "Disbursal Details",
  sanctionLetterPartA: "Sanction Letter Part-A",
  esignPartA: "Esign Part-A",
  sanctionLetterPartB: "Sanction Letter Part-B",
  esignPartB: "Esign Part-B",
  btKit: "BT Kit",
  uploadKit: "Upload Kit",
  affidavit: "Affidavit",
  insuranceEligiblity: "Insurance Eligiblity",
  insuranceLetter: "Insurance Letter",
  insuranceEsign: "Insurance E-sign",
  collateralEvaluation:"Collateral Valuation",
  repaymentSchdule: "Repayment Schedule",
  preApproval:"Pre Approval",
  deviationApproval:"Deviation Approval",
  collateralDicrepancyApproval:"Collateral Approval",
  creditAssessment:"Credit Assessment",
  CreditAssessmentLetter:"Credit Assessment Letter",
  CreditAssessmentEsign:"Credit Assessment E-sign",
};

export const thirdPartyIntegrationNames = {
  faceLiveNess:"FACELIVENESS",
  faceMatch:"FACEMATCH",
}
export const thirdPartyIntegrationVendorNames = {
  digio:"DIGIO",
  digitap:"DIGITAP",
}

export const insuranceEligibilityData = {
  updated:"update"
}

export const headerLabel={
  approval : "For Approval Details",
  applicant: "Applicant",
  applicantbt: "Applicant BT",
  loanAppId: "LOAN APP ID:",
  bank:"Account Details",
  review:"REVIEW SCREEN",
  pawan:"Pawan Ticket Details",
  lender:"Lender Details",
  nominee:"Nominee Details",
  disbursal:"Disbursal Details",
  colletral:"Collateral Valuation Details",
  ornament:"Loan Details",
  document:"Document Capture",
  esignPartA:"Esign Part - A",
  esign:"Esign",
  esignPartB:"Esign Part - B",
  insuranceEligiblity:"Insurance Eligibility",
  insuranceEsign:"Esign Insurance",
  insuranceLetter:"Insurance Letter",
  sanctionLetterPartB:"Sanction Letter Part-B",
  sanctionLetterPartA:"Sanction Letter Part-A",
  sanctionLetter:"Sanction Letter",
  descisionDetail:"Decision Details",
  afiidavit:"Affidavit",
  discrepancyApproval:"Discrepancy Approval",
  preApproval:"Pre Approval",
  deviationApproval:"Deviation Approval",
  collateralDicrepancyApproval:"Collateral Approval",
  loanInformation:"Loan Information"
}

export const basicImageDimensions = [{width:'600', height:'600'}]

export const completeTableColumns =[
    { id: "applicationid", label: "Application ID" , show:true },
    { id: "created", label: "Created By" , show:true },
    { id: "formNumber", label: "Application Number" , show:true },
    { id: "accountNumberDisplay", label: "Loan Account Number" , show:true },
    { id: "linkedBranch", label:"Sourcer Branch Name" , show:true},
    { id: "customerid", label: "Customer Id" , show:true },
    { id: "customerName", label: "Customer Name" , show:true },
    {id: "branchCode", label:"Branch Code", show:true},
    {id: "disbursalAmount", label:"Disbursal Amount", show:true},
    {id: "disbursalDate", label:"Disbursal Date", show:true},
     { id: "productType", label: "Product Type", show:true },
    { id: "type", label: "Application Type" , show:true },
  ]

  export const nonEditableTableColumns = [
      "Particulars",
      "Purity",
      "Count",
      "Gross Wt (Gm)",
      "Stone Wt (Gm)",
      "Deduction",
      "Net Wt (Gm)",
      "22K Eq Net Wt (Gm)",
      "Source Of Own.",
      "Pkt Size",
      "Pkt No.",
      "Pkt Seal No.",
      "Ornament Photo",
      "Action"
    ];
export const kycDocumentTypes = [
  { displayName: "Aadhaar Card", value: "AADHAR" },
  { displayName: "PAN Card", value: "PAN" },
  { displayName: "Driving License", value: "DRIVING_LICENSE" },
  { displayName: "Voter ID", value: "VOTER_ID" },
  { displayName: "Passport", value: "PASSPORT" },
];

export const insurancePaymentMethod = [
   { code: "IFL QR Code", name: "IFL QR Code" },
    { code: "Cash", name: "Cash" },
]

  export  const denialReasonsList = {
      loanwise:{
        DUE_DELIGENCE: "Due diligence failed",
        DISBURSAL_PRESENT:"Already Disbursal Present on Loan",
        LOAN_MATURITY_NOT_IN_30_DAYS: "Loan is not matured ",
        PENDING_INTEREST:"Please Pay Up to date Interest First through Payment Option.",
        LOAN_NOT_AUDITED:"Loan not audited",
        OVERDUE_PENDING: "Total Overdue is greater than 0.",
        LOAN_MATURED: "Loan already matured",
        NPA_LOAN: "Loan is NPA",
        LOAN_NOT_IN_ACTIVE_STATUS:"Loan is closed/under closure",
        LTV_GREATER_THAN_THRESHOLD:"Ltv is greather than threshold",
        PAYABLE_PRESENT:"Customer payable amount is present",
        LOAN_SCHEME_NOT_AVAILABLE:"Scheme is not available for this loan eligiblity",
        ZERO_MAX_TOPUP_AMOUNT:"Top up amount should be greather than 0",
        GREATER_OUTSTANDING_AMOUNT:"Outstanding amount should be less than topup amount",
        UNDER_LOCK_IN_PERIOD:"Loan is under locking period",
      },
      custIdWise: {
        LOAN_MARKING: "Your loan account is marked as death/legal.",
        AUDITED_AS_SPURIOUS_OR_UNACCEPTABLE_ITEM: "Audited as spurious or unacceptable item",
      },
    };

  export const tabId = {
    ornament: "ORNAMENT",
    applicant: "APPLICANT",
    lender: "LENDER",
    pawan: "PAWAN",
    review: "REVIEW",
    bank: "BANK",
    nominee: "NOMINEE",
    document: "DOCUMENT",
    disbursal: "DISBURSAL",
    forApproval: "FOR_APPROVAL",
    esignA: "ESIGN_A",
    esignB: "ESIGN_B",
    collateralApproval: "COLLATERALEVALUATION",
    sanctionLetterPartA:"SANCTIONLETTER_PARTA",
    sanctionLetterPartB:"SANCTIONLETTER_PARTB",
    insuranceEsign:"INSURANCE_ESIGN",
    insurance:"INSURANCE",
    insuranceLetter:"INSURANCE_LETTER",
    affidavit:"AFFIDAVIT",
    uploadKit:"UPLOADKIT",
    btKit:"BTKIT",
    repaymentSchedule: "REPAYMENT_SCHEDULE",
    preApproval:"Pre Approval",
    deviationApproval:"Deviation Approval",
    collateralDicrepancyApproval:"Collateral Approval",
    creditAssessment:"CREDIT_ASSESSMENT",
    CreditAssessmentLetter:"Credit Assessment Letter",
    CreditAssessmentEsign:"Credit Assessment E-sign",
};

export const customerTypeData = [
    { code: "Individual", name: "Individual" },
    { code: "Employee", name: "Employee" },
]

export const repaymentScheduleTableHeader =[
    { id: "installmentAmount", label: "Installment Amount" },
    { id: "principalAmount", label: "Principal Amount" },
    { id: "interestAmount", label: "interest Amount"},
    { id: "openingBalance", label: "Opening Balance" },
    { id: "installmentDueDate", label: "Installment Due Date" },
  ]
export const loanValidationTypeList = {
  maxNetWeightPercentage:'maxNetWeightPercentage'
}

export const colateralApprovalData = {
  tableColumns:[
    { id: "id", label: "ID"},
    { id: "leadId", label: "Lead Id" },
    { id: "sender", label: "Created By" },
    { id: "loanAccountNumber", label: "Loan Account Number" },
    { id: "customerId", label: "Customer Id" },
    { id: "branchCode", label: "Branch Code" },
    { id: "discrepancy", label: "Discrepancy Loans" },
    { id: "status", label: "Status" },
  ],
  statusCode:"COLLATERALAPPROVAL",
  decisionList:[
    {code:"NO_DISCREPENCY",name:"No Discrepancy"},
    {code:"DISCREPANCY",name:"Discrepancy"}
  ]
}
export const DeviationApprovalData = {
  tableColumns:[
    { id: "id", label: "ID"},
    { id: "leadId", label: "Lead Id" },
    { id: "sender", label: "Created By" },
    { id: "loanAccountNumber", label: "Loan Account Number" },
    { id: "customerId", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id: "loanAmount", label: "Loan Amount" },
    { id: "applicationType", label: "Application Type" },
    { id: "branchCode", label: "Branch Name" },
    { id: "productType", label: "Product Type" },
    { id: "status", label: "Status" },
  ],
  statusCode:"DEVIATION",
  decisionList:[
    {code:"REALIZED",name:"Approve"},
    {code:"REJECTED",name:"Reject"},
    {code:"SENDBACK",name:"Send Back"}

  ]
}
export const PreSanctionApprovalData = {
  tableColumns:[
    { id: "applicationid", label: "Application ID" },
    { id: "created", label: "Created By" },
    { id: "formNumber", label: "Application Number" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id: "productType", label: "Product Type" },
    { id: "type", label: "Application Type" },
  ],
  statusCode:"PRESANCTION",
  approvalTableColumns: [
    { id: "designation", label: "Designation" },
    { id: "name", label: "Name" },
    { id: "username", label: "Username" },
  ],
  approvalCollateralColumns: [
    { id: "level", label: "Level" },
    { id: "name", label: "Name" },
    { id: "role", label: "Role" },
    { id: "designationCode", label: "Designation Code" },
    { id: "approved", label: "Approved" },
  ]
}

export const repaymentSchduleColumns = [
   { id: "loanAmount", label: "Loan Amount" },
    { id: "interestCalculationType", label: "Interest Calculation Type" },
    { id: "interestRate", label: "Interest Rate" },
    { id: "installmentAmount", label: "Installment Amount" },
    { id: "interestAmount", label: "Interest Amount" },
    { id: "disbursalDate", label: "Disbursal Date" },
    { id: "daysMethod", label: "Days Method" },
    { id: "totalAmount", label: "Total Amount" },
    { id: "action", label: "Installments" },
]

export const installmentsColumns = [
      { id: "installmentDueDate", label: "Due Date" },
      { id: "openingBalance", label: "Opening Balance" },
      { id: "principalAmount", label: "Principal Amount" },
      { id: "interestAmount", label: "Interest Amount" },
      { id: "installmentAmount", label: "Installment Amount" },
]

export const presanctionApprovalTable= [
    { id: "code", label: "Code" },
    { id: "orginal", label: "Original Value" },
    { id: "updated", label: "Revised Value" },
    { id: "value", label: "Value" },
  ]

export const referralList = [
    { code: "Direct", name: "Direct" },
    { code: "Internal", name: "Internal" },
    { code: "Digital_Marketing", name: "Digital Marketing" },
    { code: "Existing_Customer", name: "Existing Customer" },
  ];
export const deviationTableColumns = [
    {id:"name", label: "Name"},
    {id:"hierarchyCode",label:"Designation Code"},
    {id:"date",label:"Date"},
    {id:"remarks",label:"Remarks"},
    {id:"deviationCode",label:"Deviations"},
    {id:"approved",label:"Approved"},
  ];

export const CollateralEvaluationTableColumns = [
    { id: "applicationid", label: "Application ID" },
    { id: "created", label: "Created By" },
    { id: "formNumber", label: "Application Number" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id: "branchName", label: "Branch Name" },
    { id: "type", label: "Application Type" },
  ];
export   const forApprovalTableColumns = [
    { id: "applicationid", label: "Application ID" },
    { id: "created", label: "Created By" },
    { id: "formNumber", label: "Application Number" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id: "branchName", label: "Branch Name" },
    { id: "productType", label: "Product Type" },
    { id: "type", label: "Application Type" },
  ];

export const rejectedTableColumns = [
    { id: "applicationid", label: "Application ID", show:true},
    { id: "created", label: "Created By", show:true },
    { id: "formNumber", label: "Application Number", show:true },
    { id: "accountNumber", label:"Loan Account Number", show:true },
    { id: "linkedBranch", label:"Sourcer Branch Name" , show:true},
    { id: "customerid", label: "Customer Id", show:true },
    { id: "customerName", label: "Customer Name", show:true },
    { id: "branchCode", label: "Branch Code", show:true },
    { id: "productType", label: "Product Type", show:true },
    { id: "type", label: "Application Type", show:true },
  ]

  export const particularDesignationAccess = ["MAIN USER"]

  export const AADHAAR_DOC_NAMES = [
  "ADHAAR CARD",
  "AADHAR CARD",
  "ADHAR CARD",
];

  export const BLANK_VALUE = "";
  export const ZERO_VALUE = 0;
  export const showMaskedCodeLos = "MASKED_DATA_LOS"


export const purposeOfLoanNewList = {
  meanPurposeOfLoanList : ["Consumption","Income Generation"],
  consumption: "Consumption",
  income:"Income Generation",
  incomeGeneratedPurposeOfLoan:["Agriculture Purpose","Business Purpose"],
  agriculture:"Agriculture Purpose",
  business:"Business Purpose",
  agricultureList:["Khatoni Copy/ land record/Mandi Receipts"],
  businessList:["GST Certificate","Udyam Aadhaar Certificate","Bank Statement Of Firm(Last 3 months)","Income Tax Returns (ITR)/Financials"],
} 

export const maxAge = 70
export const minAge = 21
export const occupationDetailsActualLoanAmount = 1000000
export const creditAssessmentLetterAmount = 249999
export const creditApiAmountBtCase = 500000

export const aadharNames = ["adhaar card", "aadhar card", "aadhar_card", "adhar_card"];
export const creditAssessmentFields = {
  purposeOfLoan: "Purpose Of Loan",
  purposeOfLoanType: "Purpose Of Loan Type",
  householdExpenses: "Household Expenses",
  annualIncome: "Income",
  debtRecoveryAmount: "Debt Recovery Amount",
  salePropertyAmount: "Sale Property Amount",
  salePropertyAddress: "Sale Property Address",
  familySettlementAmount: "Family Settlement Amount",
  additionalDetails: "Additional Details",
  additionSource:"Additional Source",
  additionalAmount: "Additional Amount",
  inflowLabel: "Annual Inflow Details",
  inflowLabelLoanDetails: "Inflow Details",
  outflowLabel: "Annual Outflow Details",
  address:"Address",
  showAddressSource:"sale of property",
  showFamilyDetailsSource:"other family member income/savings",
  creditScore: "Credit Score",
  EmiObligation: "Other Bank/NBFC Emi Obligations",
  attachment:"Attachment",
  currentInterest:"Current Loan Interest",
  prevInterest:"Previous Loan Interest",
  totalOutstading:"Outstanding Amount",
  attachementType:"Attachment Type",
  cibilObligations:"View CIBIL Obligations",
};

export const familyDetailsFields = {
  name:"Name",
  relationship:"Relation Ship",
  number:"Mobile Number",
  income:"Income",
  header:"Family Details"
}

export const collateralTypeList = [
  { code: "JEWELLERY", name: "Jewellery" },
  { code: "ORNAMENTS", name: "Ornaments" },
  { code: "COINS", name: "Coins" }
]

export const statusList = {
  success:"SUCCESS",
  failure:"FAILURE",
  failed:"FAILED",
  inProcess:"INPROCESS",
  initiated:"INITIATED",
}
export const isValidPincode = (pincode) => {
  return /^\d{6}$/.test(pincode?.toString().trim());
};

export const getApplicationFromDate = () =>
  startOfDay(subDays(new Date(), 6));

export const dataMapLabels = {
  foirValue: "FOIR Value",
  maxEligigbleAmount: "Max Eligible Amount",
};

export const CARAT_COLOUR_LIST = [
  { id: "D", name: "D" },
  { id: "E", name: "E" },
  { id: "F", name: "F" },
  { id: "G", name: "G" },
  { id: "H", name: "H" },
  { id: "I", name: "I" },
  { id: "J", name: "J" },
  { id: "K", name: "K" },
  { id: "L", name: "L" },
  { id: "M", name: "M" },
];

export const CARAT_CLARITY_LIST = [
  { id: "FL", name: "FL" },
  { id: "IF", name: "IF" },
  { id: "VVS-1", name: "VVS-1" },
  { id: "VVS-2", name: "VVS-2" },
  { id: "VS-1", name: "VS-1" },
  { id: "VS-2", name: "VS-2" },
  { id: "SI-1", name: "SI-1" },
  { id: "SI-2", name: "SI-2" },
  { id: "I-1", name: "I-1" },
  { id: "I-2", name: "I-2" },
];
export const productType=[{
    "name": "Gold Loan",
    "code": "Gold Loan",
    "active": true
}]

export const loanTypes = {
  goldLoan: "Gold Loan",
  silverLoan: "Silver Loan",
  diamondLoan: "Diamond Loan",
}